class MobileMenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#MobileMenuDrawer-Overlay')?.addEventListener('click', this.close.bind(this));

    this.addEventListener('click', (evt) => {
      const toggle = evt.target.closest('[data-submenu-toggle]');
      if (toggle) {
        this.openSubmenu(toggle);
        return;
      }

      const back = evt.target.closest('[data-submenu-back]');
      if (back) {
        this.closeSubmenu(back.closest('[data-submenu]'));
      }
    });
  }

  openSubmenu(toggle) {
    const submenu = this.querySelector(`#${toggle.dataset.submenuToggle}`);
    submenu?.classList.add('mobile-menu-drawer__submenu--open');
  }

  closeSubmenu(submenu) {
    submenu?.classList.remove('mobile-menu-drawer__submenu--open');
  }

  open(triggeredBy) {
    // if (triggeredBy) {
    //   this.activeElement = triggeredBy;
    //   triggeredBy.classList.add('mobile-menu-drawer-trigger--active');
    //   triggeredBy.setAttribute('aria-expanded', 'true');
    // }

    const header = document.querySelector('.section-header');
    if (header) {
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(header.getBoundingClientRect().bottom)}px`
      );
    }

    this.classList.add('active');
    document.body.classList.add('overflow-hidden');

    const containerToTrapFocusOn = this.querySelector('.mobile-menu-drawer__inner');
    trapFocus(containerToTrapFocusOn);
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    this.activeElement?.classList.remove('mobile-menu-drawer-trigger--active');
    this.activeElement?.setAttribute('aria-expanded', 'false');
    removeTrapFocus(this.activeElement);

    this.querySelectorAll('.mobile-menu-drawer__submenu--open').forEach((submenu) => {
      submenu.classList.remove('mobile-menu-drawer__submenu--open');
    });
  }
}

customElements.define('mobile-menu-drawer', MobileMenuDrawer);
